import { getEnumValues } from './get-enum-values';
export enum DominantSide {
    Left = 'Left',
    Right = 'Right',
    Ambidextrous = 'Ambidextrous',
}
export const DominantSideValues = getEnumValues<DominantSide>(DominantSide);